import { notify } from "@ceyper-common";

export function notImplemented() {
    notify({
        type: "message",
        level: "warn",
        title: "Not implemented",
        message: "",
    });
}
